module.exports = __webpack_public_path__ + "img/yx2-en.3a0e38ae.jpg";